<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-dialog
      v-model="dialog"
      dismissable
      max-width="600px"
      eager
      class="pa-0"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="red"
          dark
        >
          <v-card-title class="pa-0">
            {{ title }}
          </v-card-title>
        </v-toolbar>
        <v-card-text
          v-for="(item, index) in message"
          :key="index"
        >
          <v-icon class="red--text">
            mdi-chat-alert
          </v-icon><span class="red--text">{{ item[0] }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    name: 'AlertSuccess',
    props: ['title', 'message', 'toggleDialog'],
    data () {
      return {
        dialog: false,
      }
    },
    watch: {
      toggleDialog (val) {
        if (val) {
          this.dialog = val
        }
      },
    },
  }
</script>
